import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Kindergarten } from '@isophi/core-legacy';

import { RouterLinkFactory } from '../../../../core/router/router-link.factory';
import { UserService } from '../../../../core/services/user.service';

@Component({
  selector: 'app-user-filter',
  templateUrl: './user-filter.component.html',
  styleUrls: ['./user-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserFilterComponent {
  loggedKindergarten: Kindergarten;

  constructor(protected links: RouterLinkFactory, private userService: UserService) {
    this.loggedKindergarten = this.userService.loggedKindergarten;
  }
}
